import { Entity } from '@api';
import { BrandAndProductDrawer } from '@terminal/modules/brand-and-product-drawer/BrandAndProductDrawer';
import styles from './BrandsAndProductsTab.module.scss';
import { BrandsAndProductsTable } from './brands-and-products-table/BrandsAndProductsTable';

export interface BrandsAndProductsTabProps {
  entity: Entity;
}

export const BrandsAndProductsTab = ({ entity }: BrandsAndProductsTabProps) => {
  return (
    <div className={styles.root} data-testid="brands-and-products-tab">
      <div className={styles.tabContent}>
        <BrandsAndProductsTable entity={entity} />
      </div>
      <BrandAndProductDrawer entity={entity} />
    </div>
  );
};
